import React from "react";
import Step1 from "../../../components/Visitor/Request/Step1";

const Step1Request = () => {
  return (
    <div className="min-h-screen bg-black pt-28 pb-12 px-4 md:px-6">
      <Step1 />
    </div>
  );
};

export default Step1Request;
